/*********************************************************************************************
 * Initialize the sticky CTA behavior.
 */
function initializeStickyCTA() {
	const fixedCTA = document.getElementById("mm-fixed-btn");

	const CTA = document.querySelector(".mm-pf-cta-sticky-container");

	if (CTA) {
		function isInViewport(el) {
			const cta = el.getBoundingClientRect();
			return cta.bottom >= 50; // (104) Header + Announcement bar height
		}
		
        isInViewport(fixedCTA) ? CTA.classList.remove("fixed") : CTA.classList.add("fixed");
	}
}

/*********************************************************************************************
 * Initialize the Splide carousel for the main product slider.
 *
 */
function mmSlideProduct() {
	var splideElemMain = document.querySelector("#main-slider");

	if (splideElemMain) {
		var main = new Splide(splideElemMain, {
			type: "slide",
			pagination: true,
			arrows: true,
			perPage: 1,
			breakpoints: {
				768: {
					padding: {
						right: 40,
					},
				},
			},
		});
		main.mount();
	}
}

/*********************************************************************************************
 * Initialize the Splide carousel for the reassurance slider.
 *
 */
function mmSlideProductReassurance() {
	var splideElemMain = document.querySelector("#slider-reassurance");

	if (splideElemMain) {
		var main = new Splide(splideElemMain, {
			type: "slide",
			rewind: true,
			pagination: true,
			arrows: false,
			autoplay: true,
			interval: 5000,
			perPage: 1,
		});
		main.mount();
	}
}

/*********************************************************************************************
 * Change the quantity value in the input field and update the related prices.
 *
 * @param {number} delta - The change to apply to the current quantity (e.g., +1 or -1).
 * @param {string} inputId - The ID of the input field where the quantity is adjusted.
 */
function mmChangeQtty(delta, inputId) {
  let input = document.getElementById(inputId);
  const qttyContainer = input.closest(".mm-product-form-component-quantity");
  const variantId = input.dataset.variantId
	const plusBtn = qttyContainer.querySelector(`[data-qtty-plus="${inputId}"]`);
  //console.log("plusBtn", plusBtn);


  let newValue = parseInt(input.value, 10) + parseInt(delta, 10);

	if (delta === -1 && input.value === "1") {
	} else {
    // Vérification si la nouvelle valeur atteint ou dépasse le maximum autorisé
    if (input.max && newValue >= parseInt(input.max, 10)) {
      newValue = parseInt(input.max, 10); // Limiter à la valeur maximale
      plusBtn.setAttribute("disabled", "true"); // Désactiver le bouton "+"
    } else {
      plusBtn.removeAttribute("disabled"); // Réactiver le bouton "+" si on est en dessous de la limite
    }

    // Mise à jour des prix en fonction de la nouvelle quantité
    // mmUpdatePrice(newValue);
  }

  toggleQttyIcon(newValue);
  changeFormat(newValue);

  // input.dispatchEvent(new Event("change"));

}

function checkChangeQuantity() {
  const formatOptions = document.querySelectorAll('input[name="format-option"]');
  // console.log(formatOptions.closest(".mm-pf-formats-container"));


  if (formatOptions) {
    formatOptions.forEach((format) => {
      //console.log(format.closest(".mm-pf-formats-container"));
      format.addEventListener("click", (event) => {
        //console.log('format', format);

        const quantitySelectorContainer = document.querySelector(".mm-pf-cta-item-in-cart");
        const quantityInput = quantitySelectorContainer.querySelector(".mm-product-form-component-quantity input:not(.hidden)");
        //console.log("quantityInput", quantityInput);
        const selected_variant_id = quantityInput.dataset.variantId
        const selectedFormat = event.target.value;

        // Action supplémentaire si nécessaire lors de la validation finale
        //console.log("Valeur finale après validation:", selectedFormat);

        toggleQttyIcon(selectedFormat);

      });
    })
  }
}

function changeFormat(newValue) {
  //console.log(newValue)
  const formatOptions = document.querySelectorAll('input[name="format-option"]');
  //console.log("formatOptions", formatOptions);

  if (formatOptions) {
    let selectedFormat = null;
    formatOptions.forEach((format) => {
      //console.log('value format', format.value);

      if (newValue >= format.value) {
        //console.log("format checked", format.value, newValue);
        selectedFormat = format;
      }

      // Cocher le format sélectionné
      //console.log('selectedFormat', selectedFormat);

      selectedFormat.checked = true;

      // console.log("format value", format.value);
    })

  }
}

/*********************************************************************************************
 * Update the displayed prices based on the new quantity.
 *
 * @param {number} qtty - The current product quantity used to calculate the prices.
 */
function mmUpdatePrice(qtty) {
	let priceAll = document.querySelectorAll("[data-price]");
	let comparePriceAll = document.querySelectorAll("[data-compare-price]");

	// Met à jour les prix normaux
	priceAll.forEach(function (price) {
    let priceEuro = price.querySelector(".mm-product-price-euro");
    let priceCents = price.querySelector(".mm-product-price-centimes");

		let priceValue = parseFloat(price.dataset.price);
    // console.log('price value', priceValue);

		if (!isNaN(priceValue)) {
      let priceTotal = ((priceValue * qtty) / 100).toFixed(2)
      let [euros, cents] = priceTotal.split(".");
      cents = cents || "00"
      if (priceEuro && priceCents) {
        priceEuro.textContent = euros + ",";
        priceCents.textContent = cents + "€";
      }
		} else {
			console.error("Valeur de prix non valide : ", price.dataset.price);
		}
	});

	// Met à jour les prix comparatifs
	comparePriceAll.forEach(function (comparePrice) {
		var comparePriceValue = parseFloat(comparePrice.dataset.comparePrice);
		if (!isNaN(comparePriceValue)) {
			comparePrice.innerHTML = ((comparePriceValue * qtty) / 100).toFixed(2) + "€";
		} else {
			console.error("Valeur de prix comparatif non valide : ", comparePrice.dataset.comparePrice);
		}
	});
}


function toggleQttyIcon(qtty) {
  const deleteIcon = document.querySelector(".mm-pc-delete-icon");
  const minusIcon = document.querySelector(".mm-pc-minus-icon");
  if (qtty <= 1) {
    minusIcon.classList.add("mm-none");
    deleteIcon.classList.remove("mm-none");
  } else {
    minusIcon.classList.remove("mm-none");
		deleteIcon.classList.add("mm-none");
  }
}


/*********************************************************************************************
 * Class for handling variant selection
 *
 */
class VariantSelector extends HTMLElement {
	constructor() {
		super();
		this.cached = {};
		this.container = this.closest("#product-form");
		this.addEventListener("change", this.onVariantChange);
        //console.log('test change varaint');
	}

	/*********************************************************************************************
	 * Handle variant change event.
	 *
	 */
	onVariantChange() {
		this.getSelectedOptions();
		this.getSelectedVariant();

		if (this.currentVariant) {
			this.updateURL();
			if (this.dataset.imageVariant) {
				this.updateImagesVariant();
			} else {
				this.updateMedia();
			}
			this.variantFetch();
		}
	}

	/*********************************************************************************************
	 * Get selected options from the variant checkboxes.
	 *
	 */
	getSelectedOptions() {
		this.options = Array.from(this.querySelectorAll(".mm-product-variant-checkbox:checked"), (checkbox) => checkbox.value);
	}

	/*********************************************************************************************
	 * Get variant data from the embedded JSON.
	 *
	 * @returns {Object} - The variant data.
	 */
	getVariantJSON() {
		this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}

	/*********************************************************************************************
	 * Get the selected variant based on selected options.
	 *
	 */
	getSelectedVariant() {
		this.currentVariant = this.getVariantJSON().find((variant) => {
			const findings = !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);

			if (findings) return variant;
		});
	}

	/*********************************************************************************************
	 * Update the URL to include the selected variant ID.
	 *
	 */
	updateURL() {
		window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}

	/*********************************************************************************************
	 * Fetch variant data from the server and cache it.
	 *
	 */
	variantFetch() {
		var variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

		fetch(variantUrl)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, "text/html");
				//this.cached[variantUrl] = html;
				this.renderVariantInfo(html);
                const input = document.querySelector('.mm-pf-format-value input:checked');
                if(input) { mmChangeDynamicFormatPrice(input) };
			}).then(() => {

        // checkChangeQuantity();
		    // changeFormat();
      })
			.catch((e) => {
				console.error(e);
			});
	}

	/*********************************************************************************************
	 * Render variant information in the DOM.
	 *
	 * @param {Document} html - The HTML document containing the variant information.
	 */
	renderVariantInfo(html) {
      // console.log('this.currentVariant.id', this.currentVariant.id)
    
        // Mettez à jour les éléments visibles dans le DOM
        this.updateElementOuter("#variant_id_input", html);
        //this.updateElementOuter(".mm-product-price", html);
        //this.updateMultipleElement(".mm-product-form-variant-value", html);
        this.updateMultipleElement(".mm-reload", html);
        //this.updateElementOuter(".mm-product-form-price-cta-container", html);
        //this.updateElementOuter(".mm-pf-raison-anti-gaspi-container", html);
        //this.updateElementOuter(".mm-product-form-component-format", html);
        //this.updateElementOuter(".mm-product-cta-classic", html);
    
        //initProductFormatSelection();
        this.updateImagesVariant();
    }


	/*********************************************************************************************
	 * Update the inner HTML of an element.
	 *
	 * @param {string} selector - The CSS selector of the element to update.
	 * @param {HTMLElement} html - The HTML element containing the new content.
	 */
	updateElement(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.innerHTML = source.innerHTML;
	}

	/*********************************************************************************************
	 * Update the outer HTML of an element.
	 *
	 * @param {string} selector - The CSS selector of the element to update.
	 * @param {HTMLElement} html - The HTML element containing the new content.
	 */
	updateElementOuter(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);

		if (source && destination) destination.outerHTML = source.outerHTML;
	}

	/*********************************************************************************************
	 * Update the outer HTML of multiple elements.
	 *
	 * @param {string} selector - The CSS selector of the element to update.
	 * @param {HTMLElement} html - The HTML element containing the new content.
	 */
	updateMultipleElement(selector, html) {
		const destination = document.querySelectorAll(selector);
		const source = html.querySelectorAll(selector);

		if (source && destination) {
			for (let index = 0; index < source.length; index++) {
				destination[index].outerHTML = source[index].outerHTML;
			}
		}
	}

	/*********************************************************************************************
	 * Update the media carousel to display the featured media of the current variant.
	 *
	 */
	updateMedia() {
		if (this.currentVariant && this.currentVariant.featured_media) {
			var variant_media_id = this.currentVariant.featured_media.id;
			var allMainMedia = document.querySelectorAll(".mm-product-medias .splide__slide");

			allMainMedia.forEach((media, index) => {
				if (media.dataset.id != null && parseInt(media.dataset.id) == variant_media_id) {
					splideMainInstance.go(index);
				}
			});
		}
	}

	/*********************************************************************************************
	 * Update the visibility of the media sliders for the current variant.
	 *
	 */
	updateImagesVariant() {
		var allMainMedia = document.querySelectorAll(".main-slider-variant");
		allMainMedia.forEach((media) => {
			if (media.dataset.variantid == this.currentVariant.id) {
				media.style.display = "flex";
			} else {
				media.style.display = "none";
			}
		});
		var allThumbnailMedia = document.querySelectorAll(".thumbnail-slider-variant");
		allThumbnailMedia.forEach((media) => {
			if (media.dataset.variantid == this.currentVariant.id) {
				media.style.display = "flex";
			} else {
				media.style.display = "none";
			}
		});
	}
}

/*********************************************************************************************
 * Define the custom element
 *
 */
customElements.define("variant-selector", VariantSelector);

/*********************************************************************************************
 * Toggle Featured IMG Product form
 *
 */

if (window.innerWidth > 1024) {
  const mediasContainer = document.querySelector(".mm-media-container");
  const productForm = document.querySelector('.mm-product-form')
  const featuredImageContainer = productForm.querySelector(".mm-pf-featured-image-container");
  const descriptionContainer = productForm.querySelector(".mm-product-form-component-description");
  const descriptionId = document.getElementById("mm-pf-product-description");


  // Vérifier que les éléments existent
  if (mediasContainer) {
      // Configuration de l'observateur
      const observer = new IntersectionObserver(
          (entries) => {
              entries.forEach((entry) => {
                  if (!entry.isIntersecting) {
                    if (featuredImageContainer) {
                      // Si l'élément sort de l'écran, ajouter la classe "active"
                      featuredImageContainer.classList.add("active");
					          }
                    if (descriptionId) {
                      descriptionContainer.classList.add('active-anchor')
					          }
                  } else {
                      if (featuredImageContainer) {
                        featuredImageContainer.classList.remove("active");
                      }
                      if (descriptionId) {
                        descriptionContainer.classList.remove("active-anchor");
						          }
                  }
              });
          },
          {
              root: null, // Root est la fenêtre du viewport
              threshold: 0, // Déclenche dès que l'élément commence à sortir
          }
      );

      // Observer le mediasContainer
      observer.observe(mediasContainer);
  }
}


/*********************************************************************************************
 * Toggle InfoBulle Date de livraison
 *
 */
function setUpToolTip() {
  const shippingDateContainer = document.querySelector(".mm-pf-shipping-date-container");
  if (shippingDateContainer) {
    const infoSvg = shippingDateContainer.querySelector(".mm-icon-infobulle");
    const infoBulle = shippingDateContainer.querySelector(".mm-pf-infobulle-container");
    if (infoSvg && infoBulle) {
  		// Afficher l'infobulle au survol
  		infoSvg.addEventListener("mouseenter", () => {
  			infoBulle.classList.add("visible"); // Ajoute la classe visible
  		});
  
  		// Cacher l'infobulle lorsque la souris quitte
  		infoSvg.addEventListener("mouseleave", () => {
  			infoBulle.classList.remove("visible"); // Supprime la classe visible
  		});
    }
  }  
}
document.addEventListener("DOMContentLoaded", (event) => {
  setUpToolTip();
});

/*********************************************************************************************
 * Truncate Description
 *
 */
function mmToggleDescr() {
	let trunDescriptions = document.querySelectorAll(".mm-truncate-descr");
	trunDescriptions.forEach(function (descr) {
		descr.classList.toggle("mm-none");
	});
}

/*********************************************************************************************
 * Loaded Listenner
 *
 */
document.addEventListener("DOMContentLoaded", () => {
	mmSlideProduct();
	mmSlideProductReassurance();
	initializeStickyCTA();
    // checkChangeQuantity();
});

document.addEventListener("scroll", () => {
	initializeStickyCTA();
});

/*********************************************************************************************
 * Splide Products reco
 *
 */
document.addEventListener('DOMContentLoaded', function () {
    waitForElement();

    function waitForElement() {
        var routineSections = document.querySelectorAll('[data-section-products-reco-id]');

        routineSections.forEach(function (section) {
            var id = '.mm-products-reco-splide';
            var splideElem = section.querySelector(id);

            if (splideElem != null && splideElem.querySelectorAll(".splide__slide").length > 0) {
                mmSplideInit(splideElem, section);
            } else {
                setTimeout(waitForElement, 2000);
            }
        });
    }

    function mmSplideInit(splideElem, section) {
        var splideInstance = new Splide(splideElem, {
            type        : 'slide',
            arrows      : true,
            pagination  : false,
            gap         : '20px',
            fixedWidth  : '165px',
			snap		: true,
			speed 		: '1000',
            perMove     : 1,
            omitEnd     : true,
            padding     : {
                left: '10px',
                right: '10px'
            },
            breakpoints : {
                768: {
					gap     	: '10px',
					fixedWidth  : '210px',
                    padding		: {
						left		: '15px',
						right		: '15px',
                    }
                }
            }
        }).mount();

        // Ajout de la fonction de mise à jour de la barre de progression
        var bar = section.querySelector('.my-carousel-progress .my-carousel-progress-bar');

        function updateProgressBar() {
            var end = splideInstance.Components.Controller.getEnd() + 1; // Nombre total de slides
            var rate = Math.min((splideInstance.index + 1) / end, 1); // Calcul du ratio
            if (bar) {
                bar.style.width = String(100 * rate) + '%';
            }
        }

        // Mise à jour initiale
        updateProgressBar();

        // Mise à jour lors des mouvements ou drag du carrousel
        splideInstance.on('moved', updateProgressBar);
        splideInstance.on('dragged', updateProgressBar);

        // Ajoute l'écouteur d'événement de défilement à splideElem
        splideElem.addEventListener('wheel', function (e) {
            // Ne pas empêcher le comportement par défaut si le défilement est vertical
            if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
                return;
            }

            // Empêche le comportement par défaut uniquement pour le défilement horizontal
            e.preventDefault();

            // Incrémente le compteur de défilements
            scrollCounter++;

            // Vérifie si le compteur atteint le seuil pour un mouvement
            if (scrollCounter >= 12) {
                // Réinitialise le compteur
                scrollCounter = 0;

                // Déplace la diapositive selon la direction du défilement horizontal
                if (e.deltaX < 0) {
                    splideInstance.go('<'); // Mouvement vers la gauche
                } else if (e.deltaX > 0) {
                    splideInstance.go('>'); // Mouvement vers la droite
                }
            }
        });
    }
});

// Refresh Product Form
async function renderShopifySection(sectionId, productHandle) {

    const section_id_sm = sectionId.replace('shopify-section-', '')
    const variant_id = document.querySelector("input[name='id']").value;

    // URL de l'API Shopify Section Render
    const sectionRenderUrl = `/products/${productHandle}?section_id=${section_id_sm}&variant=${variant_id.value}`;

    try {
        // Effectuer la requête pour récupérer le HTML de la section
        const response = await fetch(sectionRenderUrl);

        // Vérification de l'état de la réponse
        if (!response.ok) {
            throw new Error(`Erreur lors de la récupération de la section : ${response.statusText}`);
        }

        // Parse du contenu HTML récupéré
        const sectionHtml = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(sectionHtml, 'text/html');

        // Sélectionner l'élément sur la page où injecter le HTML
        const sectionElement = document.querySelector(`#${sectionId}`);
        if (!sectionElement) {
            throw new Error(`L'élément avec l'ID #${sectionId} n'existe pas sur la page.`);
        }

        // Injecter le HTML dans l'élément cible
        const old_form_content = sectionElement.querySelector('.shopify-product-form');
        const new_form_content = doc.querySelector('.shopify-product-form');
        const selected_variant = old_form_content.querySelector('.mm-product-variant-checkbox:checked');
        let selected_format_value = null;
        if (selected_variant) {
          const selected_variant_id = selected_variant.dataset.id;
          old_form_content.innerHTML = new_form_content.innerHTML;
          old_form_content.querySelector(`.mm-product-variant-checkbox[data-id="${selected_variant_id}"]`).checked = true;
          const event = new Event("change");
          document.querySelector('variant-selector').dispatchEvent(event);
          initializeStickyCTA();
        } else {
          old_form_content.innerHTML = new_form_content.innerHTML;
        }
      
        // Ici on relance les event listener
        initRiveOnLoad();
        setUpToolTip();
      
        const changeEvent = new Event("change");
        const selectedInput = document.querySelector('.mm-pf-format-value input:checked');

        if(selectedInput) {
          selectedInput.dispatchEvent(changeEvent);        
        }

        // Restaurer l'état du CTA si nécessaire
        const variantId = document.querySelector('#variant_id_input').value;
        const isProductInCart = variantId && typeof mmGetCartItemQuantity === 'function' ? mmGetCartItemQuantity(variantId) > 0 : false;
        if (isProductInCart && typeof refreshCTAComponent === 'function') {
            refreshCTAComponent(variantId);
        }
     
    } catch (error) {
        console.error("Une erreur s'est produite :", error);
    }
}

function initProductFormatSelection() { 
    // Sélectionner toutes les options de format (boutons radio)
    const formatOptions = document.querySelectorAll('input[name="format-option"]');
    const addToCartButton = document.querySelector('.mm-product-cta.mm-btn.mm-btn-primary.mm-pf-cta-add-to-cart'); // Bouton Ajouter au panier
    const formatActiveSpan = document.getElementById('format-active'); // Span qui affiche la quantité active

    // Ajout d'un écouteur d'événements pour chaque option de format
    formatOptions.forEach(option => {
        option.addEventListener('change', function () {
            // Récupérer la nouvelle quantité sélectionnée à partir de l'option sélectionnée
            const selectedQuantity = this.value;

            // Mettre à jour le texte de l'élément <span id="format-active">
            if (formatActiveSpan) {
                formatActiveSpan.textContent = selectedQuantity;
            }

            // Mettre à jour l'attribut data-selected-quantity du bouton "Ajouter au panier"
            if (addToCartButton) {
                addToCartButton.setAttribute('data-selected-quantity', selectedQuantity);
            }
        });
    });
}

// Activer la fonction au chargement du DOM
// document.addEventListener('DOMContentLoaded', initProductFormatSelection);

// Update format prices dynamically on change when item is not in cart
function mmChangeDynamicFormatPrice(input) {
  // Update selected format
  const selected_variant_id = document.getElementById('variant_id_input').value;
  const selected_format_input = document.querySelector(`#mmCurrentFormat[data-variant-id="${selected_variant_id}"`);
  selected_format_input.value = input.value;
  
  const is_in_cart = document.getElementById('formatInfo').dataset.isInCart;

  //console.log('INSIDE :', input)

  // Update price
  const price = input.dataset.price;
  const price_euros = price.split(',')[0];
  const price_cts = price.split(',')[1];
  
  document.querySelector('#mmProductPrice .mm-product-price-euro').innerHTML = `${price_euros},`;
  document.querySelector('#mmProductPrice .mm-product-price-centimes').innerHTML = price_cts;

  // Update discount
  const priceCent = input.dataset.centimes;
  const comparePrice = document.querySelector('.mm-product-compare-at-price s').dataset.comparePrice;
  const discount = calculerRemise(comparePrice, priceCent);
  const discountHtmlElem = document.querySelector('.mm-variant-pill-reduce');
  // console.log('priceCent', priceCent)
  // console.log('comparePrice', comparePrice)
  // console.log(`-${discount}%`)
  if (discountHtmlElem) {
    if (discount > 0) {
      // discountHtmlElem.innerText = `-${discount}%`;
      discountHtmlElem.style.display = 'block';
    } else {
      discountHtmlElem.style.display = 'none';      
    }
  }

  // Update unit price
  const unit_price = parseInt(input.dataset.centimes) / 100;
  const str = document.querySelector('.mm-pf-product-format').innerText;
  const unit_weight = parseInt(str.match(/\d+/)[0]);
  const k_price = unit_price * 1000 / unit_weight;

  const old_text_split = document.querySelector('.mm-pf-product-price-unit').innerText.split('€');
  document.querySelectorAll('.mm-pf-product-price-unit').forEach(function(elem) {
    elem.innerText = `${k_price.toFixed(2)} €${old_text_split[1]}`;
  })
}

function calculerRemise(comparePrice, priceCent) {
    if (comparePrice <= 0) {
        throw new Error("Le prix original doit être supérieur à 0.");
    }
    let remise = ((comparePrice - priceCent) / comparePrice) * 100;
    return remise.toFixed(0); // On arrondit
}


const input = document.querySelector('.mm-pf-format-value input:checked');
if(input) { mmChangeDynamicFormatPrice(input) };



/* =========================
   PANIER — EVENTS & MEDIAS
   ========================= */


document.addEventListener("DOMContentLoaded", () => {
  const root = document.querySelector(".mm-main-product-grid");
  if (!root || root.dataset.isPanier !== "true") return;

  const wrap = root.querySelector("[data-mm-panier-medias]");
  if (!wrap) return;



/* MAIN / THUMBS HOVER & CLICK
   ========================= */

const mains = Array.from(wrap.querySelectorAll(".mm-panier-main-item"));
const thumbs = Array.from(wrap.querySelectorAll(".mm-panier-thumb"));
if (mains.length <= 1 || thumbs.length === 0) return;

const DEFAULT_IDX = 0;
let activeIdx = DEFAULT_IDX;

// Détection tactile (mobile/tablette)
const isTouch = window.matchMedia("(hover: none) and (pointer: coarse)").matches;

// thumbs = images[1..] (offset:1 en Liquid)
const thumbToMainIndex = (thumbEl) => {
  const raw = thumbEl.dataset.index;
  const n = Number(raw);
  if (Number.isFinite(n)) return n + 1;

  const i = thumbs.indexOf(thumbEl);
  return i >= 0 ? i + 1 : DEFAULT_IDX;
};

const setActive = (idx) => {
  activeIdx = idx;
  const target = String(idx);

  mains.forEach((el) => {
    el.classList.toggle("is-active", el.dataset.index === target);
  });

  thumbs.forEach((btn, i) => {
    btn.classList.toggle("is-active", idx === i + 1);
  });
};


/* =========================
   DESKTOP-ONLY : hover + reset au mouseleave
   (⚠️ ne jamais binder ça sur mobile)
   ========================= */
if (!isTouch) {
  thumbs.forEach((btn) => {
    const mainIdx = thumbToMainIndex(btn);
    btn.addEventListener("mouseenter", () => setActive(mainIdx));
  });

  const thumbsCol = wrap.querySelector(".mm-panier-thumbs");
  if (thumbsCol) {
    thumbsCol.addEventListener("mouseleave", () => setActive(DEFAULT_IDX));
  }
}

/* =========================
   CLIC / TAP
   ========================= */
if (isTouch) {
  // Mobile: tap = toggle
  thumbs.forEach((btn) => {
    const mainIdx = thumbToMainIndex(btn);
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      setActive(activeIdx === mainIdx ? DEFAULT_IDX : mainIdx);
    });
  });
  
  // ✅ Tap n'importe où en dehors du couloir => reset
    const thumbsCol = wrap.querySelector(".mm-panier-thumbs");
    if (thumbsCol) {
      document.addEventListener(
        "pointerdown",
        (e) => {
          // si tap dans le couloir => ne rien faire
          if (thumbsCol.contains(e.target)) return;

          // sinon reset
          setActive(DEFAULT_IDX);
        },
        true // capture = plus fiable sur mobile
      );
    }

} else {
  // Desktop: click = select (fallback)
  thumbs.forEach((btn) => {
    const mainIdx = thumbToMainIndex(btn);
    btn.addEventListener("click", () => setActive(mainIdx));
  });
}


/* =========================
   CHEVRONS SCROLL (↑ ↓ / ← →)
   ========================= */

  function initPanierScrollHints() {
  const thumbs = wrap.querySelector(".mm-panier-thumbs");
  if (!thumbs) return;

  const items = Array.from(thumbs.querySelectorAll(".mm-panier-thumb"));
  if (items.length < 2) return;

  const firstThumb = items[0];
  const lastThumb = items[items.length - 1];

  const isHorizontal = () => window.matchMedia("(max-width: 768px)").matches;

  // scroll réel : track si présent, sinon thumbs
  const track = thumbs.querySelector(".mm-panier-thumbs-track");
  const scroller = track || thumbs;

  const step = () =>
    isHorizontal()
      ? Math.round(scroller.clientWidth * 0.6)
      : Math.round(scroller.clientHeight * 0.6);

  // helpers création bouton
  const ensureBtn = (selector, className, ariaLabel, insertFn) => {
    let btn = thumbs.querySelector(selector);
    if (!btn) {
      btn = document.createElement("button");
      btn.type = "button";
      btn.className = className;
      btn.setAttribute("aria-label", ariaLabel);
      btn.textContent = "⌃";
      insertFn(btn);
    }
    return btn;
  };

  // Desktop: UP / DOWN
  const btnDown = ensureBtn(
    ".mm-panier-scrollhint--down",
    "mm-panier-scrollhint mm-panier-scrollhint--down",
    "Voir plus",
    (btn) => thumbs.appendChild(btn)
  );

  const btnUp = ensureBtn(
    ".mm-panier-scrollhint--up",
    "mm-panier-scrollhint mm-panier-scrollhint--up",
    "Revenir",
    (btn) => {
      const header = thumbs.querySelector(".mm-panier-thumbs-header");
      if (header) thumbs.insertBefore(btn, header.nextSibling);
      else thumbs.insertBefore(btn, thumbs.firstChild);
    }
  );

  // Mobile: LEFT / RIGHT
  const btnRight = ensureBtn(
    ".mm-panier-scrollhint--right",
    "mm-panier-scrollhint mm-panier-scrollhint--right",
    "Voir à droite",
    (btn) => thumbs.appendChild(btn)
  );

  const btnLeft = ensureBtn(
    ".mm-panier-scrollhint--left",
    "mm-panier-scrollhint mm-panier-scrollhint--left",
    "Voir à gauche",
    (btn) => thumbs.appendChild(btn)
  );

  // Click handlers (bind 1 fois)
  const bindOnce = (btn, handler) => {
    if (!btn) return;
    if (btn.dataset.bound) return;
    btn.addEventListener("click", handler);
    btn.dataset.bound = "1";
  };

  bindOnce(btnDown, () => {
    scroller.scrollBy({
      top: isHorizontal() ? 0 : step(),
      left: isHorizontal() ? 0 : 0,
      behavior: "smooth",
    });
  });

  bindOnce(btnUp, () => {
    scroller.scrollBy({
      top: isHorizontal() ? 0 : -step(),
      left: isHorizontal() ? 0 : 0,
      behavior: "smooth",
    });
  });

  bindOnce(btnRight, () => {
    scroller.scrollBy({
      top: 0,
      left: isHorizontal() ? step() : 0,
      behavior: "smooth",
    });
  });

  bindOnce(btnLeft, () => {
    scroller.scrollBy({
      top: 0,
      left: isHorizontal() ? -step() : 0,
      behavior: "smooth",
    });
  });

  // Si pas de scroll possible => cacher tout
  const canScroll =
    scroller.scrollHeight > scroller.clientHeight + 2 ||
    scroller.scrollWidth > scroller.clientWidth + 2;

  if (!canScroll) {
    btnUp.classList.add("is-hidden");
    btnDown.classList.add("is-hidden");
    btnLeft.classList.add("is-hidden");
    btnRight.classList.add("is-hidden");
    return;
  }

  // IntersectionObserver : cacher selon 1er/dernier visible
  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.target === firstThumb) {
          // début => cacher UP (desktop) et LEFT (mobile)
          btnUp.classList.toggle("is-hidden", entry.isIntersecting);
          btnLeft.classList.toggle("is-hidden", entry.isIntersecting);
        }
        if (entry.target === lastThumb) {
          // fin => cacher DOWN (desktop) et RIGHT (mobile)
          btnDown.classList.toggle("is-hidden", entry.isIntersecting);
          btnRight.classList.toggle("is-hidden", entry.isIntersecting);
        }
      }
    },
    { root: scroller, threshold: 0.85 }
  );

  io.observe(firstThumb);
  io.observe(lastThumb);

  // IMPORTANT: on ne "supprime" rien ici.
  // Le show/hide desktop vs mobile sera géré en CSS (plus safe).
}


initPanierScrollHints();


});



















